export default "__VITE_ASSET__Eu1vobp___"